export default __webpack_public_path__ + "static/media/Ellipse 2.990ee7b6.svg";